export enum HttpStatusCode {
	UnknownError = 0,
	BadRequest = 400,
	Unauthorized = 401,
	Forbidden = 403,
	NotFound = 404,
	MethodNotAllowed = 405,
	Conflict = 409,
	ServerError = 500,
}
